import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BridgeCreatePage } from '@/features/admin/bridges/bridge-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau bridge. */
export const Route = createFileRoute('/$tenant/bridges/new')({ component: NewBridgeRoute });

function NewBridgeRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="bridges"
      crumbs={[{ label: t('nav.items.bridges') }, { label: t('admin.bridges.newTitle') }]}
    >
      <BridgeCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
